import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import { Async } from "react-select";

const SuperAdminFields = (props) => (
	<React.Fragment>
		<FormGroup>
			<ControlLabel>Reports to</ControlLabel>
			<Async
				onChange={(option) => { props.onAsyncChange(option, "reporter_id"); }}
				name="reporter_id"
				placeholder="Choose user"
				value={props.selectedUser}
				labelKey="full_name"
				valueKey="id"
				loadOptions={(e,c) => props.handleAsyncSearch(e,"user",`roles=1,2,4&exclude=${props.user_id}`,c)}
				clearable
				multi={false}
			/>
		</FormGroup>
	</React.Fragment>
);

SuperAdminFields.defaultProps = {
	selectedUser: PropTypes.object,
	user_id: null
};

SuperAdminFields.propTypes = {
	user_id: PropTypes.string,
	selectedUser: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string
	}),
	onAsyncChange: PropTypes.func.isRequired,
	handleAsyncSearch: PropTypes.func.isRequired,
};

export default SuperAdminFields;


// WEBPACK FOOTER //
// ./src/components/forms/users/fields/SuperAdminFields.js